import { TableItem, Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { messageError } from '../../../Statements/Table/constants';
import { positionWarrantyWidthCols } from '../TableHead/constants';

interface PositionWarrantyItemProps {}

export const PositionWarrantyItem: React.FC<PositionWarrantyItemProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });

  const positionWarrantyType = '28/05/2023';
  const positionWarrantyAsset = 'JUROS';
  const positionWarrantyQuantityDeposited = messageError;
  const positionWarrantyValue = 'R$ 46,00';

  if (isMobile) {
    return (
      <VStack alignItems="center" justifyContent="space-between" space={Spacing['inline.nano']}>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Tipo
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyType}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Ativo
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyAsset}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Qtd. depositada
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyQuantityDeposited}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Valor
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyValue}
          </Text>
        </HStack>
      </VStack>
    );
  }

  if (isTablet) {
    return (
      <HStack alignItems="center" justifyContent="space-between" mb={Spacing['stack.xxxs']}>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Tipo
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyType}
          </Text>
        </VStack>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Ativo
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyAsset}
          </Text>
        </VStack>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Qtd. depositada
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyQuantityDeposited}
          </Text>
        </VStack>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Valor
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {positionWarrantyValue}
          </Text>
        </VStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center">
      <TableItem
        testId="position-warranty-type-item"
        width={positionWarrantyWidthCols.positionWarrantyType.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {positionWarrantyType}
        </Text>
      </TableItem>
      <TableItem
        testId="position-warranty-asset-item"
        width={positionWarrantyWidthCols.positionWarrantyAsset.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {positionWarrantyAsset}
        </Text>
      </TableItem>
      <TableItem
        testId="position-warranty-quantity-deposited-item"
        width={positionWarrantyWidthCols.positionWarrantyQuantityDeposited.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {positionWarrantyQuantityDeposited}
        </Text>
      </TableItem>
      <TableItem
        testId="position-warranty-value-item"
        width={positionWarrantyWidthCols.positionWarrantyValue.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {positionWarrantyValue}
        </Text>
      </TableItem>
    </HStack>
  );
};
